import { ICreator } from "../../../../../types/models/creator.models.types";
import { usePostHttp } from "../../../http.hook";

export interface IPostKycActionResponse {
  creator: ICreator;
}

export function useApproveGstAdminHttp() {
  return usePostHttp<null, IPostKycActionResponse>({
    path: "/admin/kyc/creator/:creatorId/gst/approve",
  });
}
